<template>
  <div class="table-keyword">
    <div class="row m-b-20">
      <div class="col-md-12" align="right">
        <button
          aria-label=""
          v-on:click="addKeyword"
          class="btn btn-success btn-icon-left"
          type="button"
        >
        <i class="bi bi-plus"></i> <span class="">Tambah Keyword</span>
        </button>
      </div>
    </div>

    <div class="table-responsive m-b-20">
      <table class="table table-bordered" id="daftar_keyword">
        <thead>
          <tr>
            <th width="5%">No</th>
            <th>Topik</th>
            <th>Keyword</th>
            <th>Exclude</th>
            <th width="20%">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="data_keyword == null">
            <td colspan="5">
              <loader-component />
            </td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-responsive" v-if="tipe == 1">
      <table
        class="table table-bordered"
        id="daftar_keyword_formed"
      >
        <thead>
          <tr>
            <th width="5%">No</th>
            <th>Topik</th>
            <th>Keyword</th>
            <th>Exclude</th>
            <th width="20%">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="data_keyword_formed == null">
            <td colspan="5">
              <loader-component />
            </td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
            <td style="display: none"></td>
          </tr>
        </tbody>
      </table>
    </div>
    <floating-loader-component v-if="is_loading" />
    <modal-dynamic-component
      v-if="currentModal != null"
      :key="modal_key"
      :modal="currentModal"
      :data="modal_data"
      :static="true"
    />
  </div>
</template>

<script>
import $ from "jquery";
import swal from "sweetalert";
import modal_add_keyword from "@/views/components/settings/keyword/modal_add_keyword.vue";
import modal_edit_keyword from "@/views/components/settings/keyword/modal_edit_keyword.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import loader_component from "@/views/components/loader.vue";
import floating_loader from "@/views/components/floating_loader.vue";

export default {
  name: "table_keyword",
  components: {
    "modal-dynamic-component": modal_dynamic,
    "loader-component": loader_component,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      data_keyword: null,
      data_keyword_formed: null,
      isError: false,
      currentModal: null,
      table: null,
      table_formed: null,
      modal_data: [],
      modal_key: 0,
      id_project: this.$store.getters.user.id_project,
      tipe: this.$store.getters.user.project.project_detail.tipe,
      is_loading: false,
    };
  },
  methods: {
    getKeyword: function () {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "new-keywords/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status == 204) {
            self.data_keyword = {};
            self.isError = false;
          } else {
            self.data_keyword = response.data.sosmed;
            if (self.tipe == 1) {
              self.data_keyword_formed = response.data.formed;
            }

            self.isError = false;
            let btn;
            self.table.clear().draw();
            for (let index in self.data_keyword) {
              btn =
                '<button class="btn btn-sm btn-complete m-r-5 ch" data-tipe="1"><i class="bi bi-pencil-square"></i></button><button class="btn btn-sm btn-danger del" data-tipe="1"><i class="bi bi-trash"></i></button>';
              self.table.row
                .add([
                  parseInt(index) + 1,
                  self.data_keyword[index].topic,
                  self.data_keyword[index].keyword,
                  self.data_keyword[index].excludes,
                  btn,
                ])
                .node().id = self.data_keyword[index].topic_id;
              self.table.draw(false);
            }

            if (self.tipe == 1) {
              self.table_formed.clear().draw();
              for (let index in self.data_keyword_formed) {
                btn =
                  '<button class="btn btn-sm btn-complete m-r-5 ch" data-tipe="2"><i class="bi bi-pencil-square"></i></button><button class="btn btn-sm btn-danger del" data-tipe="2"><i class="bi bi-trash"></i></button>';
                self.table_formed.row
                  .add([
                    parseInt(index) + 1,
                    self.data_keyword_formed[index].topic,
                    self.data_keyword_formed[index].keyword,
                    self.data_keyword_formed[index].excludes,
                    btn,
                  ])
                  .node().id = self.data_keyword_formed[index].topic_id;
                self.table_formed.draw(false);
              }
            }
          }
        })
        .catch(function (err) {
          self.resp = err.response;
          self.isError = true;
        });
    },
    addKeyword: function () {
      this.currentModal = {};
      this.currentModal.title = "Tambah Keyword";
      this.currentModal.subtitle =
        "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan";
      this.currentModal.component = modal_add_keyword;
      this.modal_key++;
    },
    deletekeyword: function (topic_id, keyword, tipe) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus keyword tersebut.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          this.is_loading = true;
          let params = {
            _id: topic_id,
            keyword: keyword,
            tipe: parseInt(tipe),
          };
          let api = process.env.VUE_APP_API_URL + "new-keyword-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.getKeyword();
                self.$parent.$parent.getChannelStatus();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Keyword berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function (error) {
              console.log(error);
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus keyword.',
                  position: "top",
                  timeout: 4000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.is_loading = false;
            });
        }
      });
    },
    editKeyword: function (topic_id, data) {
      this.currentModal = {};
      this.currentModal.title = "Edit Keyword";
      this.currentModal.subtitle =
        "Silahkan masukan kata kunci yang akan dimonitor dan kata yang akan dikecualikan";
      this.currentModal.component = modal_edit_keyword;
      this.modal_data = [];
      this.modal_data["topic_id"] = topic_id;
      this.modal_data["keyword"] = data[2];
      this.modal_data["excludes"] = data[3];
      this.modal_data["tipe"] = data["tipe"];

      this.modal_key++;
    },
  },
  mounted: function () {
    this.table = $("#daftar_keyword").DataTable();
    if (this.tipe == 1) {
      this.table_formed = $("#daftar_keyword_formed").DataTable();
    }
    this.getKeyword();
    let self = this;
    $("#daftar_keyword tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      var data = self.table.row(tr).data();
      let tipe = $(this).attr("data-tipe");
      self.deletekeyword(id, data[2], tipe);
    });
    $("#daftar_keyword tbody").on("click", ".ch", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      var data = self.table.row(tr).data();
      data["tipe"] = $(this).attr("data-tipe");
      self.editKeyword(id, data);
    });
    if (this.tipe == 1) {
      $("#daftar_keyword_formed tbody").on("click", ".del", function () {
        var tr = $(this).closest("tr");
        let id = $(tr).attr("id");
        var data = self.table_formed.row(tr).data();
        let tipe = $(this).attr("data-tipe");
        self.deletekeyword(id, data[2], tipe);
      });
      $("#daftar_keyword_formed tbody").on("click", ".ch", function () {
        var tr = $(this).closest("tr");
        let id = $(tr).attr("id");
        var data = self.table_formed.row(tr).data();
        data["tipe"] = $(this).attr("data-tipe");
        self.editKeyword(id, data);
      });
    }
  },
};
</script>
